import * as Types from '@/types';

import { gql } from '@apollo/client';
export const PricingInvoiceHistoryFieldsFragmentDoc = gql`
  fragment PricingInvoiceHistoryFields on DetailVariantPackInvoiceHistoryEntry {
    gross_margin_percentage
    invoice_date
    price_in_micros
    quantity
  }
`;
